<template>
  <div>
    <GmapMap
      ref="map"
      :center="center"
      :zoom="12"
      map-type-id="terrain"
      style="width: 100%; height: 400px"
    >
      <GmapMarker
        v-for="corp in corporationsWithLocation"
        :key="corp.id"
        :position="{ lat: corp.location.latitude, lng: corp.location.longitude }"
        :clickable="true"
        :title="corp.corporation_name"
        @click="selected = corp"
      />
      <GmapInfoWindow
        v-if="selected"
        :position="{ lat: selected.location.latitude, lng: selected.location.longitude }"
        :opened="!!selected"
        @closeclick="selected = null"
      >
        <div>
          <strong>{{ selected.corporation_name }}</strong>
          <div v-if="selected.address">{{ selected.address }}</div>
        </div>
      </GmapInfoWindow>
    </GmapMap>
    <p v-if="!loading && corporationsWithLocation.length === 0" class="text-muted" style="margin-top: 10px;">
      Konumu tanımlı bir işletme yok. İşletme Yönetimi'nden bir işletmeye konum ekleyin.
    </p>
  </div>
</template>
<script>
  import { mapState } from 'vuex'

  export default {
    mounted() {
      const self = this
      self.loading = true
      self.$store.dispatch('Corporation/requestCorporationList').finally(() => {
        self.loading = false
      })
    },
    computed: {
      ...mapState({
        corporations: (state) => state.Corporation.corporations,
      }),
      corporationsWithLocation() {
        const list = this.corporations.corporations || []
        return list.filter((c) => c.location)
      },
      center() {
        if (this.corporationsWithLocation.length) {
          const first = this.corporationsWithLocation[0].location
          return { lat: first.latitude, lng: first.longitude }
        }
        return { lat: 41.0054632, lng: 28.8473736 }
      },
    },
    data () {
      return {
        loading: false,
        selected: null,
      }
    },
  }
</script>
